module.exports = __webpack_public_path__ + "assets/img/title-3695d7a4.png";